import { Autoplay, Pagination, Navigation } from "swiper";
import {Swiper,SwiperSlide} from 'swiper/react';
import {BsFillStarFill} from 'react-icons/bs';

import useFetch from "../Hooks/useFetch";

import 'swiper/css';
import "swiper/css/pagination";
import "swiper/css/navigation";

const Hero = ()=>{
    const key = process.env.REACT_APP_API_KEY;
    const {results} = useFetch(`https://api.themoviedb.org/3/movie/popular?api_key=${key}&language=en-US&page=1`);
       // console.log(results[0].backdrop_path);
    return <div className="hidden md:block mt-8">
        {(results.length>0)?
        <Swiper
        spaceBetween={30}
        centeredSlides={true}
        autoplay={{
          delay: 10000,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        navigation={true}
        modules={[Autoplay, Pagination, Navigation]}
        className="mySwiper"
        >
            {results.map(item=>{
                return <SwiperSlide key={item.id}>
                    <section style={{backgroundImage:`url(https://image.tmdb.org/t/p/original${item.backdrop_path})`}} className='flex flex-col justify-center lg:min-h-[90vh] md:min-h-[40vh] bg-center bg-cover min-w-full px-2 lg:px-8' >
                        <h1 className="text-headline dark:text-headline-dark lg:text-4xl md:text-xl text-lg font-heading lg:mb-8 mb-4 bg-gray-100 dark:bg-secondary-dark opacity-90 lg:max-w-lg md:max-w-md p-2 w-fit">{item.title}</h1>
                        <p className="text-paragraph dark:text-paragraph-dark font-body lg:text-lg md:text-md text-sm lg:max-w-2xl md:max-w-md w-fit bg-gray-100 dark:bg-secondary-dark p-2 opacity-90">{item.overview}</p>
                        <span className="flex flex-row lg:mt-8 md:mt-4 dark:text-headline-dark text-headline">
                            <h3 className="bg-gray-100 dark:bg-secondary-dark lg:max-w-lg md:max-w-md p-2 w-fit font-heading opacity-90">{item.release_date}</h3>
                            <h3 className="flex flex-row items-center bg-gray-100 dark:bg-secondary-dark lg:max-w-lg md:max-w-md p-2 w-fit font-heading ml-4 opacity-90"><BsFillStarFill className="text-[orange]"/> {item.vote_average}</h3>

                        </span>
                    </section>
                </SwiperSlide>
            })}
        </Swiper>
        :
        null
        }
    </div>
}

export default Hero;